import React from 'react'

import ProductVariantsModal from './modal/ProductVariantsModal'

import { getImageUrl, Sizes } from '../components/blocks/editable/Img'

import General from '../utils/General'
import Currency from '../utils/Currency'
import Cart from '../utils/Cart'
import Event from "../utils/Event";
import Navigation from "../utils/Navigation";
import BadgeBlock from './BadgeBlock'

export default class Product extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      quantity: 1,
      variant: [],
      shop : props.shop,
      product: props.product,
    }

  }

  componentDidMount() {
    this._setup()
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps, () => this._setup())
  }

  _setup(){
    General.updateLazyBackgroundImages()
  }

  _renderPrice(product){
    let price = product.cycle1_price
    let currency = window.CURRENT_CAMPAIGN?.currencySymbol
    const compareAtPrice = product.compareAtPrice

    if(product.on_sale){
      return (
        <>
          <span className="h4 type--strikethrough m-0 pr-1">{ Currency.symbolFormat(price, currency) }</span>
          <span className="h4 m-0">{ Currency.symbolFormat(price, currency) }</span>
        </>
      )
    }

    if(product.variants.length > 0){
      if(product.variants[0].price){
        price = product.variants[0].price
      }
    }

    return <>
      {compareAtPrice > 0 && <span class="h4 type--strikethrough m-0 pr-1">{ Currency.symbolFormat(compareAtPrice, currency) }</span>}
      <span class="h4 m-0">{ Currency.symbolFormat(price, currency) }</span>
    </>
  }

  render() {
    let {
      product,
      quantity,
      variant,
      showProductVariantsModal
    } = this.state

    if(product == null){
      return (
        <div class="col-md-4">
          <div class="feature feature-1 position-relative">
            <div className="shimmer w-100" style={{height: 290 }}/>
          </div>
        </div>
      )
    }

    let buttonClassName = "col-12"

    let variantOptions = Cart.getOptions(product)
    let customMessageOptions = Cart.getCustomMessageOptions(product)

    let showAddCart = (variantOptions && Object.entries(variantOptions).length < 1) && (customMessageOptions && customMessageOptions.length < 1)

    let cartButtonText = "Add To Cart";
    const checkoutType = window.CURRENT_WEBSITE.checkout_type;
    if(checkoutType === "instant"){
      cartButtonText = "Buy Now"
    }
    const isBoth = (checkoutType === "instantAndCart") || (checkoutType === "instantAndBuy");
    if(showAddCart){
      buttonClassName = "col-6"
    }

    let productClassName = "col-md-4"
    if(window.CURRENT_WEBSITE.extra?.product_page_settings?.column_no === 2){
      productClassName = "col-md-6"
    }else if(window.CURRENT_WEBSITE.extra?.product_page_settings?.column_no === 4){
      productClassName = "col-md-3"
    }

    return (
      <div class={`${productClassName} tile-product item`}>
        <div class="feature feature-1 position-relative">
          {
            product.on_sale &&
            <span class="label product-sale-price">Sale</span>
          }
          <a
            class="block"
            priority={this.props.index}
            href={Navigation.getUrl(`/shop/product/${product.campaignProductId}`)}
          >
            <span
              class="tile-image block lazy-background lazy-visible"
              style ={{ backgroundImage: "url("+getImageUrl({original: product.imageUrl}, "product")+")" }}
            >
              &nbsp;
            </span>
          </a>
          <div class="feature__body boxed boxed--border pb-0 bt-0 btr-0">
            <h5>{ product.productName }</h5>
            <div class="d-flex align-items-center price">
              {this._renderPrice(product)}
            </div>
            {/* starts, buttons  */}
            <div className="row buttons no-gutters">
              <div className={buttonClassName}>
                {isBoth && showAddCart ? (
                  <a
                    className="btn btn--primary btn-left btn-products px-0 w-100"
                    onClick={() => {
                      window.CURRENT_WEBSITE.checkout_type = "instantAndBuy";
                      this.props.onAddToCartPressed(product, null, [], quantity);
                    }}
                  >
                    <span className="btn__text">Buy Now</span>
                  </a>
                ) : (
                  <a
                    className="btn btn--primary btn-left btn-products px-0"
                    href={Navigation.getUrl(`/shop/product/${product.campaignProductId}`)}
                  >
                    <span className="btn__text">More Details</span>
                  </a>
                )}
              </div>
              {showAddCart && (
                <div className="col-6">
                  <a
                    className="btn btn--primary btn-right btn-products px-0 w-100"
                    onClick={() => {
                      if (isBoth) {
                        window.CURRENT_WEBSITE.checkout_type = "instantAndCart";
                      }
                      this.props.onAddToCartPressed(product, null, [], quantity);
                    }}
                  >
                    <span className="btn__text">
                      {isBoth ? "Add To Cart" : cartButtonText}
                    </span>
                  </a>
                </div>
              )}
            </div>
            {/* end, buttons  */}
          </div>
          <BadgeBlock product={product} />
        </div>
      </div>
    )
  }
}
